import { useMemo } from "react";

import { isAutoEnrolledInventoryProgram, useGetAllFieldPracticesByFarm } from "utils";

import { FarmResponse, FieldListField } from "models";

import { useFieldStatusMap } from "pages/app/all-field-view/hooks/useFieldStatusMap";
import { HomeFieldStats, summariseFieldStats } from "pages/app/home/status-cards/homeFieldStats";

/**
 * Field numbers of the home page. The practices query reads the field ids from the fields query cache, so the caller
 * must run `useGetFieldsByFarmId` for the same farm (HomeHero does).
 */
export const useHomeFieldStats = (farm: FarmResponse | undefined, fields: FieldListField[], reportingYear: number, cropYear: number) => {
  const fieldStatusMap = useFieldStatusMap(farm, reportingYear);
  const { data: fieldPractices, isLoading, isLoadingError } = useGetAllFieldPracticesByFarm(farm);
  const allFieldsEnrolled = isAutoEnrolledInventoryProgram(farm?.carbonProgram);

  const stats: HomeFieldStats = useMemo(
    () => summariseFieldStats(fields, fieldStatusMap, fieldPractices, cropYear, { allFieldsEnrolled }),
    [fields, fieldStatusMap, fieldPractices, cropYear, allFieldsEnrolled]
  );

  // a failed first load must not read as "0 % enrolled, 0 crops"; a failed refetch keeps the cached practices
  return { stats, fieldStatusMap, loading: isLoading, unavailable: !!isLoadingError };
};
